import React from 'react';

export function SortItemFilter({title, className, onChange, name, value, options = [], isNumeric = false}) {

  const handleChangeFilter = (e) => {
    onChange(name, isNumeric ? e.target.value * 1 : e.target.value);
  };

  return <div className={"sort__item " + (className ? " " + className : "")}>
    <span>{title}</span>
    <select name={name}
            className="sort__select select"
            value={value}
            onChange={handleChangeFilter}>
      {options.map(i => <option key={i.value} value={i.value}>{i.text}</option>)}
    </select>
  </div>;
}
